// Monitor do śledzenia zapytań Firestore w czasie rzeczywistym
class FirestoreMonitor {
  private static instance: FirestoreMonitor
  private reads = 0
  private writes = 0
  private deletes = 0
  private listeners: Set<() => void> = new Set()

  private constructor() {}

  static getInstance(): FirestoreMonitor {
    if (!FirestoreMonitor.instance) {
      FirestoreMonitor.instance = new FirestoreMonitor()
    }
    return FirestoreMonitor.instance
  }

  // Rejestruj odczyty (getDocs zwraca snapshot.size dokumentów)
  recordReads(count: number) {
    this.reads += count
    this.notifyListeners()
  }

  // Rejestruj zapisy
  recordWrite() {
    this.writes += 1
    this.notifyListeners()
  }

  // Rejestruj usunięcia
  recordDelete() {
    this.deletes += 1
    this.notifyListeners()
  }

  // Pobierz statystyki
  getStats() {
    return {
      reads: this.reads,
      writes: this.writes,
      deletes: this.deletes,
      total: this.reads + this.writes + this.deletes
    }
  }

  // Reset liczników
  reset() {
    this.reads = 0
    this.writes = 0
    this.deletes = 0
    this.notifyListeners()
  }

  // Subskrybuj zmiany (dla React komponenty)
  subscribe(callback: () => void) {
    this.listeners.add(callback)
    return () => this.listeners.delete(callback)
  }

  private notifyListeners() {
    this.listeners.forEach(listener => listener())
  }
}

export default FirestoreMonitor.getInstance()
